
import axiosInstance from '../../axios/instance'

/**
 * Retrieves client applications based on the provided parameters.
 *
 * @param {string} url - URL of the client application.
 * @returns {Promise<Object>} - Object with application data.
 * @throws {Error} - If an error occurs during the request or the token is missing.
 */

async function isAppFreeByCompanyName(company_name) {
    try {
        const response = await axiosInstance.get(`/api/client-applications/company?company_name=${company_name}`)
        return response.status === 204
    } catch (error) {
        console.error('Error fetching client applications data:', error)
        throw error
    }
}

export default isAppFreeByCompanyName
